module.exports = __webpack_public_path__ + "img/ic_ky_ok.2dfdde59.png";